import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardReplenishmentRoutes = [
	{
		key: "replenishment-batches",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/batches`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/BatchDashboard")),
	},
	{
		key: "replenishment-batch-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/batches/:batchUuid`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/BatchDetail")),
	},
	{
		key: "replenishment-distributor-suggestions",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/distributors/:code/suggestions`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/DistributorSuggestions")),
	},
	{
		key: "replenishment-orders",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/orders`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/ReplenishmentOrders")),
	},
	{
		key: "replenishment-overrides",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/overrides`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/OverrideHistory")),
	},
	{
		key: "replenishment-learning",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/learning`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/LearningTrustScore")),
	},
	{
		key: "replenishment-logs",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/logs`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/CalculationLogs")),
	},
	{
		key: "replenishment-log-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/logs/:batchUuid`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/CalculationLogDetail")),
	},
	{
		key: "distributor-sku-summary",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/distributor-sku-summary`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/DistributorSkuSummaryList")),
	},
	{
		key: "distributor-sku-summary-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/distributor-sku-summary/:distributorCode/stock`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/DistributorSkuSummaryDetail")),
	},
	{
		key: "replenishment-pending-approvals",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/replenishment/pending-approvals`,
		component: React.lazy(() => import("views/reward-views/replenishment/pages/PendingApprovals")),
	},
];
